import type { UpdateRestrictedWordsPayload } from '@/modules/restricted-words/types.ts'
import { RestrictedWordsSettingsItem } from '@/modules/restricted-words/ui/restricted-words-settings-item.tsx'

const items: {
  title: string
  description: string
  fieldName: keyof UpdateRestrictedWordsPayload
}[] = [
  {
    title: 'Websites',
    description: 'This will block all attempts to send websites into the chat',
    fieldName: 'websiteRestrictionEnabled',
  },
  {
    title: 'Emails',
    description: 'This will block all attempts to send emails into the chat',
    fieldName: 'emailRestrictionEnabled',
  },
  {
    title: 'Phone Numbers',
    description:
      'This will block all attempts to send phone numbers into the chat',
    fieldName: 'phoneNumberRestrictionEnabled',
  },
  {
    title: 'Crypto Wallets',
    description:
      'This will block all attempts to send crypto wallets into the chat',
    fieldName: 'cryptoWalletRestrictionEnabled',
  },
]

export const RestrictedWordsSettings = () => {
  return (
    <div className="mt-3 flex flex-wrap">
      {items.map((i) => (
        <RestrictedWordsSettingsItem
          key={i.fieldName}
          {...i}
        />
      ))}
    </div>
  )
}
